import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {Link} from 'react-router-dom';
import { db } from '../../firebase'
import Navbar from '../inc/Header';
import ScrollToTop from "react-scroll-to-top";




function Memberlist() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(750);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [member, setMember] = useState([])
    const navigate = useNavigate()

    const memberCollectionRef = collection(db, "MEMBER_LIST");
    useEffect(() => {

        const getMember = async () => {
            const data = await getDocs(memberCollectionRef);
            setMember(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getMember()
    }, [])
    return (

        <>
            <Navbar />
            <br/>
            <br/>
          
            <br />
            <br />
          
         
            <ScrollToTop smooth top="100" color="grey"/>

            <div className='bestberhamporeschool'>
            <div className="album py-1">
                <div className="container mt-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Member List</li>
                        </ol>
                    </nav>
                </div>
            </div>
            </div>
          
           <div className='memberlist'>
              <br/>
       
                <div className='SCHOOLBERHAMPORE'>
                       <div className="container">
                    <h2 className='mt-2' style={{color:"grey"}}>OUR <b>MEMBERS </b></h2>
                    </div>
                </div>
           
        <br/>
            <div className="album py-1">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" className="form-control" placeholder="Search.. " name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">
                        {member.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                val.year.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                val.house.toLowerCase().includes(searchTerm.toLowerCase())


                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((misaa) => {
                            return (

                                <div className="col-md-3">
                                    
                                    <div className="card mb-4 border-White box">
                                        <img className="card-img-top same-size-img" src={misaa.img} alt={misaa.name} />
                                        <div className="card-body">
                                        <h4 style={{color:"#641e16 "}} className="card-text"> <b>{misaa.name}</b></h4>
                                            <h6 style={{color:"#0e3c91 "}} className="card-text"> <b>{misaa.contact}</b></h6>
                                            <p className="card-text mb-1">{misaa.city}</p>
                                            <p className="card-text mb-1">House: {misaa.house}</p>
                                            <p style={{color:"#794044"}} className="card-text">Year: {misaa.year}</p>
                                            
                                            
                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>
</div>
                </div>
            </div>

        </>

    );
}

export default Memberlist;